import URI from 'urijs';
import { resolveSearchQueryRequest } from 'actions/search/searchBarActions';

async function action({ query, fetch }) {
  const searchQuery = await resolveSearchQueryRequest(fetch, query.query);
  return {
    redirect: new URI('/cars').search(searchQuery).toString(),
  };
}

export default action;
